import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import UiAccordion from "components/Custom/UiAccordion";
import UiDialog from "../../Custom/UiDialog";

import { ERRORS, LABELS, SUCCESS, TITLES, WARNINGS } from "common/lables";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";

import { DEFAULTS, NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { TRANS_APIs } from "apihandlers/transaction";
import { PRODUCT_APIs } from "apihandlers/product";
import { ORDER_APIs } from "apihandlers/order";

import AddPurchaseSkeleton from "./AddPurchaseSkeleton";

const AddPurchaseBill = (props: any) => {
  const { setDashMenu } = props;

  const addPurchaseBillRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState<any>({});
  const [rows, setRows] = useState<any>(null);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const formulaRenderer = (row) => {
    console.log("formulaRenderer: ", row);
    let quantity = Number(row["quantity"] || 0);
    let price = Number(row["price"] || 0);
    let taxStructure = row["taxStructure"];
    console.log("taxStructure", taxStructure);
    let basic = 0;
    let taxAmount = 0;
    let cgst = 0;
    let sgst = 0;
    let total = 0;
    if (!isNaN(quantity) && !isNaN(price)) {
      basic = price * quantity;
      taxAmount = basic * (taxStructure.replace("%", "") / 100);
      cgst = Number((taxAmount / 2).toFixed(2));
      sgst = Number((taxAmount / 2).toFixed(2));
      total = basic + taxAmount;
    }
    row["basic"] = basic;
    row["taxAmount"] = taxAmount;
    row["total"] = total;
    row["cgst"] = cgst;
    row["sgst"] = sgst;
    return row;
  };

  const purchaseCols = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "productName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PRODUCT,
      width: "25%",
    },
    {
      key: "closingStock",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.CLOSING_STOCK,
      width: "10%",
    },
    {
      key: "quantity",
      type: "number",
      editable: true,
      sortable: true,
      searchable: true,
      name: LABELS.QUANTITY,
      width: "10%",
      renderSum: true,
      renderSumPrefix: "Total Quantity:",
      formula: formulaRenderer,
    },
    {
      key: "price",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.RATE,
      width: "10%",
      renderSum: true,
      formula: formulaRenderer,
    },
    {
      key: "basic",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.BASIC,
      width: "10%",
      renderSum: true,
      renderSumPrefix: "Total Basic : ",
      formula: formulaRenderer,
    },
    {
      key: "cgst",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.CGST_AMOUNT,
      width: "10%",
      renderSum: true,
      renderSumPrefix: "Total CGST : ",
      formula: formulaRenderer,
    },
    {
      key: "sgst",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.SGST_AMOUNT,
      width: "10%",
      renderSum: true,
      renderSumPrefix: "Total SGST : ",
      formula: formulaRenderer,
    },
    {
      key: "total",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.AMOUNT,
      width: "10%",
      renderSum: true,
      renderSumPrefix: "Total Amount: ",
      formula: formulaRenderer,
    },
  ];

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const voucherDate = (
        document.getElementById("voucherDate") as HTMLInputElement
      ).value.trim();
      const billNo = (
        document.getElementById("billNo") as HTMLInputElement
      ).value.trim();
      const billDate = (
        document.getElementById("billDate") as HTMLInputElement
      ).value.trim();

      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
        voucherDate,
        billDate,
        billNo,
      };

      setRows(null);
      const res: any = await PRODUCT_APIs.getProductsSku(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getOrders:", error);
    }
  };

  const mangePurchaseBill = () => {
    const rows = addPurchaseBillRef.getRowData();
    const summary = addPurchaseBillRef.getSummary();
    console.log("summary", summary);
    setLoading(true);
    const args = {
      isSale: "false",
      isReturn: "false",
      orderId: -1,
      // orderNumber: "123567", ORDER NUMBER TP BE GENERATED IN BACKEND
      customerId: 70, // SELECTEDpARTY.ID
      // orderDate: "2023-10-14 10:15:05", // BACKEND
      // areaId: 6307, BACKEND ENTRY
      taxAmount: Number(
        (
          Number(summary[0].cgst.replace("Total CGST : ", "")) +
          Number(summary[0].sgst.replace("Total SGST : ", ""))
        ).toFixed(2)
      ), // frontend
      // BASIC = QTY * RATE
      // TAX AMOUNT = BASIC * TAXPC/100
      // SGST = CGST = TAX AMOUNT/2
      total: Number(
        Number(summary[0].total.replace("Total Amount: ", "")).toFixed(2)
      ), // BASIC + TAX AMOUNT
      basic: Number(
        Number(summary[0].basic.replace("Total Basic : ", "")).toFixed(2)
      ),
      status: 3, // SMALL INT
      // remarks: comments, // TEXT BOX INPUT
      //vehicleId: 33, // DONT SEND
      // branchId: 15, // FOR NOW, WE NEED TO DO IT IN BACKEND
      // stockLoadId: 2, // NULL HANDLE IN BACKEND iF MANDATORY
      // productSkuId: rows.id,
      // sold, // soldsku * gram BACKEND
      // soldSku, // THIS iS QTY
      // price,
      // orderItemBasic,
      // orderItemTaxAmount,
      // orderItemTotal,
      items: rows.map((item) => {
        return {
          orderItemId: -1,
          productSkuId: item.id,
          soldSku: item.quantity,
          price: item.price,
          itemcgstAmount: Number(
            (
              (Number(item.price * item.quantity) *
                Number(item.taxStructure.replace("%", "") / 100)) /
              2
            ).toFixed(2)
          ),
          itemsgstAmount: Number(
            (
              (Number(item.price * item.quantity) *
                Number(item.taxStructure.replace("%", "") / 100)) /
              2
            ).toFixed(2)
          ),
          orderItemBasic: Number((item.price * item.quantity).toFixed(2)),
          orderItemTaxAmount: Number(
            (
              Number(item.price * item.quantity) *
              Number(item.taxStructure.replace("%", "") / 100)
            ).toFixed(2)
          ),
          orderItemTotal: Number(
            (
              Number(item.price * item.quantity) +
              Number(
                Number(item.price * item.quantity) *
                  Number(item.taxStructure.replace("%", "") / 100)
              )
            ).toFixed(2)
          ),
        };
      }),
      // photos: [],
      // schemeId: 5, // NOT TO BE HERE, BACKEND
      // offers, // NOT TO BE SENT HERE, BACKEND
    };

    // setIsSubmit(true);

    console.log("args:", args);
    ORDER_APIs.manageOrder(args).then((res) => {
      // setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  return (
    <React.Fragment>
      <div>
        <div className="pageInfo">
          <ul className="breadcrumbs">
            <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.HOME}</li>
            <li className="dim">{" / "}</li>
            <li onClick={() => props.setDashMenu(LABELS.HOME)}>
              {LABELS.PURCHASE}
            </li>
            <li className="dim">{" / "}</li>
            <li className="active">{TITLES.ADD_PURCHASE_BILL}</li>
          </ul>
          <h4>{TITLES.ADD_PURCHASE_BILL}</h4>
        </div>
        <div>
          <div className=" filterBorder" style={{ width: "96%" }}>
            <UiAccordion id={"filter"} title={LABELS.FILTER}>
              <div className="flexRowAround">
                <div className="formGroup width30">
                  <TxtRow
                    label={LABELS.VOUCHER_DATE}
                    type={"date"}
                    id={"voucherDate"}
                    defaultValue={DateFunctions.getDate(
                      "today",
                      "from",
                      "YYYY-MM-DD"
                    )}
                  />
                </div>
                <div className="formGroup width30">
                  <TxtRow
                    id={"billNo"}
                    label={LABELS.BILL_NO}
                    defaultValue={selectedRow.billNo}
                  />
                </div>
                <div className="formGroup width30">
                  <TxtRow
                    label={LABELS.BILL_DATE}
                    type={"date"}
                    id={"billDate"}
                    defaultValue={DateFunctions.getDate(
                      "today",
                      "from",
                      "YYYY-MM-DD"
                    )}
                  />
                </div>
              </div>
            </UiAccordion>
          </div>
          {rows ? (
            <>
              <div className="grid excelGridWrapper">
                <ExcelGrid
                  id={"addPurchaseBill"}
                  childRef={addPurchaseBillRef}
                  height={window.innerHeight * 0.6}
                  cols={purchaseCols}
                  rows={rows}
                  exportOption={true}
                  newRowOption={false}
                  exportName={LABELS.ADD_PURCHASE_BILL}
                  onReload={reloadGrid}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "right",
                  width: "96.5%",
                }}
              >
                <div
                  style={{
                    width: "35%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Btn
                    text={LABELS.SAVE}
                    onClick={mangePurchaseBill}
                    marginRight={15}
                    bgColor={COLORS.GRID_ADD_NEW}
                    //  loading={isSubmit}
                  />
                </div>
              </div>
            </>
          ) : (
            <div>
              <AddPurchaseSkeleton />
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(AddPurchaseBill);
